import React from 'react';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';
import { Field } from 'redux-form';
import {
  alphabeticalAndSomeChar,
  alphabeticalOnly,
  inputField,
} from '../utilsForm';
import styles from './koinworksForm.css';

const KoinworksEmergencyContactForm = () => {
  return (
    <div className={`col-md-12 col-lg-12`}>
      <div className="col-md-3">
        <label>Emergency Contact</label>
      </div>
      <div className="col-md-9">
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Name
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="name_emergency"
              maxLength="255"
              placeholder="Name"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalOnly()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Relationship<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="relationship"
              maxLength="255"
              placeholder="Relationship"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalOnly()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Contact Number<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={PhoneNumberField}
              name="contact_number_emergency"
              type="tel"
              placeholder=""
              errorRegister
              showTextError
              customClassName={styles['account-name']}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Address
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="emergency_address"
              maxLength="255"
              placeholder="Address"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalAndSomeChar()}
            />
          </div>
        </div>
      </div>
      <div className="col-md-12 col-lg-12">
        <hr />
      </div>
    </div>
  );
};

export default KoinworksEmergencyContactForm;
